module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Simple"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a name"
    }
  }, _vm._l((_vm.data), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.user.first_name) + "\n                ")])
  }))], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Grouped"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a character",
      "icon": "account"
    }
  }, [_c('optgroup', {
    attrs: {
      "label": "Black Sails"
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vane"
    }
  }, [_vm._v("Vane")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "billy"
    }
  }, [_vm._v("Billy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jack"
    }
  }, [_vm._v("Jack")])]), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Breaking Bad"
    }
  }, [_c('option', {
    attrs: {
      "value": "heisenberg"
    }
  }, [_vm._v("Heisenberg")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jesse"
    }
  }, [_vm._v("Jesse")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "saul"
    }
  }, [_vm._v("Saul")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mike"
    }
  }, [_vm._v("Mike")])]), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Game of Thrones"
    }
  }, [_c('option', {
    attrs: {
      "value": "tyrion-lannister"
    }
  }, [_vm._v("Tyrion Lannister")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jamie-lannister"
    }
  }, [_vm._v("Jamie Lannister")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "daenerys-targaryen"
    }
  }, [_vm._v("Daenerys Targaryen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jon-snow"
    }
  }, [_vm._v("Jon Snow")])])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Error",
      "type": "is-danger",
      "message": "Something went wrong with this field"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a character"
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Rounded"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a character",
      "rounded": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Required"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a character",
      "required": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Loading"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a character",
      "loading": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Disabled"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a character",
      "disabled": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Disabled option"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a character"
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver",
      "disabled": ""
    }
  }, [_vm._v("Silver")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Expanded"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a character",
      "expanded": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c17c1d2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/select/examples/ExSimple.vue
// module id = 1167
// module chunks = 29 59